<template>
        <div id="courses-content" class="relative">
          <div id="content">

              <!-- THE ROUTE VIEW SHOULD BE HERE -->
              <div class="content-area__content">
                  <transition :name="routerTransition" mode="out-in">
                          <router-view></router-view>
                  </transition>
              </div>
          </div>
        </div>
</template>

<script>

import themeConfig from '../../themeConfig.js';
import VxSidebar from './components/vx-sidebar/VxSidebar'

export default {
    components: {
        VxSidebar
    },
    data() {
        return {
            routerTransition: themeConfig.routerTransition || 'none',
            clickNotClose: true,
            isCourseSidebarActive: true,
            windowWidth: window.innerWidth,
        }
    },
    methods: {
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
            this.setSidebarWidth();
        },
        setSidebarWidth() {
            if(this.windowWidth < 1200) {
                this.isCourseSidebarActive = this.clickNotClose = false;
            }else {
                this.isCourseSidebarActive = this.clickNotClose = true;
            }
        },
    },

    created() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleWindowResize);
        })
        this.setSidebarWidth();
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
    },
}
</script>

<style lang="scss" scoped>
    #content, .content-area__content {
        min-height: calc(100vh - 20rem);
    }
    #course-sidebar{
        .vs-sidebar--item a{
          color: #626262
        }
        .vs-sidebar--item.active {
          a {
            color: #fff
          }
        }
    }
</style>

